import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "./../component/Header";
import Footer from "./../component/Footer";
import { API_BASE_URL, IMAGE_URL } from "../utils/app_url";
import { useLanguage } from "../context/LanguageContext";
import ProductCardSkeleton from "./../component/ProductCardSkeleton";
import HeadingSkeleton from "./../component/HeadingSkeleton";

const Blogs = () => {
  const { langJson } = useLanguage();
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}blogs`);
      const responseData = await response.json();
      const list = responseData?.data?.data ?? responseData?.data ?? responseData ?? [];
      setBlogs(Array.isArray(list) ? list : []);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching blogs:", error);
      setLoading(false);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    return new Date(dateStr).toLocaleDateString(undefined, {
      day: "numeric", month: "long", year: "numeric",
    });
  };

  return (
    <div>
      <Header />
      <style>{`body { background: #FFF; }`}</style>

      <div className="fullContainer">
        <div className="categoryDiv productSliderMain topNew tradePrdts">
          <div className="featureDiv productListMain">
            {loading ? (
              <HeadingSkeleton width="200px" height="28px" />
            ) : (
              <h2 className="storeTabHdn">{langJson?.news ?? "News"}</h2>
            )}

            <ul className="products products-4-col blogGrid">
              {loading ? (
                Array.from({ length: 6 }).map((_, index) => (
                  <ProductCardSkeleton key={index} />
                ))
              ) : blogs.length > 0 ? (
                blogs.map((item, index) => (
                  <li key={index}>
                    <Link to={`/blogs/${item?.slug}`}>
                      <div className="videoHldr blogImgHldr">
                        {item?.featured_image ? (
                          <img src={IMAGE_URL + item.featured_image} alt={item?.title} />
                        ) : (
                          <div className="newsImgPlaceholder" />
                        )}
                      </div>
                      <div className="blogCardInfo">
                        {/* <span className="blogCardCategory">{langJson?.news ?? "NEWS"}</span> */}
                        <h3 className="blogCardTitle">{item?.title}</h3>
                        {item?.author && (
                          <span className="blogCardAuthor">{item.author.toUpperCase()}</span>
                        )}
                        {item?.published_at && (
                          <span className="blogCardDate">{formatDate(item.published_at)}</span>
                        )}
                      </div>
                    </Link>
                  </li>
                ))
              ) : (
                <span className="noOrderDiv">{langJson?.norecordsfound}</span>
              )}
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Blogs;
